export const valueToDaysMap = {
    0: 0,
    1: 0,
    2: 7,
    3: 30,
    4: 90,
    5: 365,
}

export const getStartAndEndDate = (value)=>{
    const days = valueToDaysMap[value];
    const endDate = new Date();
    const startDate = new Date(endDate);
    startDate.setDate(endDate.getDate() - days);
    return {
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString()
    }
}